import { render, staticRenderFns } from "./AccessPermissions.vue?vue&type=template&id=3c064031"
import script from "./AccessPermissions.vue?vue&type=script&lang=js"
export * from "./AccessPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports